export var ThemeMode;
(function (ThemeMode) {
    ThemeMode["DARK"] = "dark";
    ThemeMode["LIGHT"] = "light";
    ThemeMode["LIGHT_MONO"] = "light_mono";
    ThemeMode["DARK_COLORED"] = "dark_colored";
})(ThemeMode || (ThemeMode = {}));
export var SuperThemeMode;
(function (SuperThemeMode) {
    SuperThemeMode["DARK"] = "dark";
    SuperThemeMode["LIGHT"] = "light";
})(SuperThemeMode || (SuperThemeMode = {}));
export var Direction;
(function (Direction) {
    Direction["LTR"] = "ltr";
    Direction["RTL"] = "rtl";
    Direction["DYNAMIC"] = "dynamic";
})(Direction || (Direction = {}));
export var Edges;
(function (Edges) {
    Edges["STRAIGHT"] = "straight";
    Edges["CURVED"] = "curved";
})(Edges || (Edges = {}));
export var Theme;
(function (Theme) {
    Theme["DARK"] = "dark";
    Theme["LIGHT"] = "light";
    Theme["DYNAMIC"] = "dynamic";
})(Theme || (Theme = {}));
export var Currencies;
(function (Currencies) {
    Currencies["AED"] = "AED";
    Currencies["BHD"] = "BHD";
    Currencies["EGP"] = "EGP";
    Currencies["EUR"] = "EUR";
    Currencies["GBP"] = "GBP";
    Currencies["KWD"] = "KWD";
    Currencies["OMR"] = "OMR";
    Currencies["QAR"] = "QAR";
    Currencies["SAR"] = "SAR";
    Currencies["USD"] = "USD";
})(Currencies || (Currencies = {}));
export var Locale;
(function (Locale) {
    Locale["AR"] = "ar";
    Locale["EN"] = "en";
    Locale["DYNAMIC"] = "dynamic";
})(Locale || (Locale = {}));
